/* Moved out of snippets/gllf-ai-image-badge.liquid (gllf-perf-v1) so browsers can cache it.
   v587: the note reads as creative inspiration and explains the picture (no "real photo coming soon"). */

(function(){
  if (window.__gllfAiBadge) return; window.__gllfAiBadge = true;
  var data = {}; try { data = JSON.parse(document.getElementById('gllf-ai-products').textContent) || {}; } catch (e) {}
  var CONCEPT = /\bai[- ]generated\b|^\s*illustration of\b/i, STYLED = /\bai[- ]styled\b/i;

  function kindOf(alt){ alt = alt || ''; return STYLED.test(alt) ? 'styled' : CONCEPT.test(alt) ? 'concept' : ''; }
  // Occasion name (from "(AI-styled Christmas setting)") -> badge icon. Unknown occasions get a gold sparkle.
  var ICONS = [
    [/christmas|holiday season|xmas/i,'ornament'],[/halloween/i,'pumpkin'],[/thanksgiving|fall|autumn/i,'maple'],
    [/valentine|wedding|anniversary|love/i,'heart'],[/mother|grandparent|bridal|shower/i,'flower'],
    [/father|black friday|cyber|birthday|gift/i,'gift'],[/easter/i,'egg'],[/patrick/i,'clover'],
    [/earth day|spring/i,'seedling'],[/arbor/i,'tree'],[/memorial|fourth|july|independence|veteran|flag/i,'star'],
    [/labor|summer/i,'sun'],[/new year/i,'sparkle'],[/winter|snow/i,'snowflake'],
    [/harvest/i,'bundle'],[/prun/i,'shears'],[/bloom|lavender/i,'sprig']
  ];
  function iconFor(kind, occ){
    if (kind !== 'styled') return 'sprig';
    for (var i = 0; i < ICONS.length; i++) if (ICONS[i][0].test(occ || '')) return ICONS[i][1];
    return occ ? 'sparkle' : 'sprig';
  }
  // Photo contest: the Grower Community gallery on live plant pages (#community-gallery, "Share your lavender" button).
  var SHARE_HASH = 'gllf-share-photo';
  function openShare(tries){
    var gal = document.getElementById('community-gallery');
    var btn = gal && gal.querySelector('[data-gpg-share-yours]');
    if (gal) gal.scrollIntoView({behavior: 'smooth', block: 'start'});
    if (btn) { setTimeout(function(){ btn.click(); }, 450); return; }
    if ((tries || 0) < 20) setTimeout(function(){ openShare((tries || 0) + 1); }, 300);
  }
  if (location.hash === '#' + SHARE_HASH) {
    if (document.readyState === 'complete') openShare(0); else window.addEventListener('load', function(){ openShare(0); });
  }
  function occasion(alt){ var m = /ai[- ]styled\s+(.*?)\s*setting/i.exec(alt || ''); return m ? m[1].trim() : ''; }
  // "Fiona English Lavender Plants & Plugs - Lavandula angustifolia" -> "Fiona English Lavender"
  function shortName(title, plant){
    var t = String(title || '').split(/\s+[-–|]\s+/)[0].trim();
    if (plant) t = t.replace(/\s+(live\s+)?plants?(\s*(&|and)\s*plugs?)?$/i, '').replace(/\s+plugs?$/i, '').trim();
    return t || String(title || '').trim();
  }
  function handleFor(img){
    var a = img.closest('a[href*="/products/"]');
    var card = img.closest('[data-product-url]');
    var href = (a && a.getAttribute('href')) || (card && card.getAttribute('data-product-url')) || '';
    var m = /\/products\/([^/?#]+)/.exec(href); if (m) return decodeURIComponent(m[1]);
    return data._page || '';
  }
  function titleFor(img, handle){
    if (data[handle] && data[handle].t) return data[handle].t;
    var card = img.closest('[data-product-title]'); if (card) return card.getAttribute('data-product-title');
    var a = img.closest('a[href*="/products/"]'); if (a && a.getAttribute('aria-label')) return a.getAttribute('aria-label');
    return (img.getAttribute('alt') || '').replace(/^(ai[- ]generated\s+)?illustration of\s+(mature\s+)?/i, '').replace(/\s+in bloom.*$/i, '').replace(/\s*\(ai[- ]styled.*$/i, '').replace(/\s*\(ai[- ]generated[^)]*\)/i, '').replace(/\bai[- ]generated\s+/i, '').trim();
  }
  function isPlant(img, handle, title){
    if (data[handle]) return data[handle].p === 1;
    return /\bin bloom\b/i.test(img.getAttribute('alt') || '') || /\b(plants?|plugs?|lavandula)\b/i.test(title || '');
  }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function copyFor(kind, name, plant, occ){
    var n = '<b>' + esc(name) + '</b>', where = occ ? 'The ' + esc(occ) + ' setting' : 'The setting';
    if (kind === 'styled') return {
      head: 'Real product · ' + (occ ? esc(occ) + ' ' : 'creative ') + 'setting',
      body: (plant ? 'This ' + n + ' comes from our own plant photo. ' : 'This is our real ' + n + ', from our own product photo. ') + where + ' around it was created digitally, just for fun, to share the season.',
      foot: (plant ? 'Your plant ships at the size you choose. ' : '') + 'For exact details, go by the description on this page.'
    };
    if (plant) return {
      head: 'Creative inspiration',
      body: 'A digitally created look at ' + n + ' in full bloom, to show the color and shape this variety is loved for.',
      foot: 'Your plant ships at the size you choose, not in full bloom. For exact details, go by the description on this page.',
      contest: true
    };
    return {
      head: 'Creative inspiration',
      body: 'A digitally created picture of ' + n + ', made to share the idea and the mood. Let it spark your own.',
      foot: 'Yours may look a little different. For exact details, go by the description on this page.'
    };
  }

  var tip = document.createElement('div'); tip.className = 'gllf-ai-tip'; tip.id = 'gllf-ai-tip'; tip.setAttribute('role', 'tooltip');
  document.body.appendChild(tip);
  var openBtn = null, hideTimer = null, shownAt = 0;
  function place(btn){
    var r = btn.getBoundingClientRect(), w = tip.offsetWidth, h = tip.offsetHeight, vw = window.innerWidth, vh = window.innerHeight;
    var left = Math.min(Math.max(12, r.left), vw - w - 12), top = r.top - h - 10;
    if (top < 12) top = Math.max(12, Math.min(vh - h - 12, r.bottom + 10));
    tip.style.left = left + 'px'; tip.style.top = top + 'px';
  }
  function show(btn){
    clearTimeout(hideTimer);
    if (openBtn && openBtn !== btn) openBtn.setAttribute('aria-expanded', 'false');
    if (openBtn !== btn || tip.dataset.open !== 'true') shownAt = Date.now();
    openBtn = btn; btn.setAttribute('aria-expanded', 'true');
    var c = copyFor(btn.dataset.kind, btn.dataset.name, btn.dataset.plant === '1', btn.dataset.occ);
    tip.dataset.kind = btn.dataset.kind;
    var share = '';
    if (c.contest && btn.dataset.handle) share = '<div class="gllf-ai-tip__share"><p>Growing ' + esc(btn.dataset.name) + '? Enter your photo in our Grower Community photo contest. A winning photo can become the featured photo for this plant, with credit to you.</p>' +
      '<a href="/products/' + encodeURIComponent(btn.dataset.handle) + '#' + SHARE_HASH + '" data-gllf-ai-share>Share your photo &rarr;</a></div>';
    tip.innerHTML = '<strong>' + c.head + '</strong><p>' + c.body + '</p><small>' + c.foot + '</small>' + share;
    tip.dataset.open = 'true'; place(btn);
  }
  function hide(now){
    clearTimeout(hideTimer);
    var go = function(){ tip.dataset.open = 'false'; if (openBtn) openBtn.setAttribute('aria-expanded', 'false'); openBtn = null; };
    if (now) go(); else hideTimer = setTimeout(go, 280);
  }
  tip.addEventListener('mouseenter', function(){ clearTimeout(hideTimer); });
  tip.addEventListener('focusin', function(){ clearTimeout(hideTimer); });
  tip.addEventListener('focusout', function(e){ if (!tip.contains(e.relatedTarget)) hide(); });
  tip.addEventListener('mouseleave', function(){ hide(); });
  tip.addEventListener('click', function(e){
    var a = e.target.closest('[data-gllf-ai-share]'); if (!a) return;
    var here = a.pathname === location.pathname && document.getElementById('community-gallery');
    if (here) { e.preventDefault(); hide(true); openShare(0); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') hide(true); });
  document.addEventListener('click', function(e){ if (openBtn && !e.target.closest('.gllf-ai-badge') && !e.target.closest('.gllf-ai-tip')) hide(true); }, true);
  window.addEventListener('scroll', function(){ if (openBtn) place(openBtn); }, {passive: true});
  window.addEventListener('resize', function(){ if (openBtn) place(openBtn); });

  // Size follows the picture: small on phone cards, large on the main product photo. Re-checked when a hidden
  // picture (slider, menu, quick look) comes into view.
  function fit(btn){
    var hw = btn.parentElement ? btn.parentElement.getBoundingClientRect().width : 0; if (!hw) return;
    btn.classList.toggle('gllf-ai-badge--sm', hw < 230); btn.classList.toggle('gllf-ai-badge--lg', hw > 520);
  }
  var sizer = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting) fit(e.target); }); }) : null;
  window.addEventListener('resize', function(){ document.querySelectorAll('.gllf-ai-badge').forEach(fit); });
  function badge(img){
    if (img.dataset.gllfAi) return;
    var kind = kindOf(img.getAttribute('alt'));
    img.dataset.gllfAi = kind || 'no';
    if (!kind) return;
    var host = img.parentElement; if (!host || host.querySelector(':scope > .gllf-ai-badge')) return;
    var cs = getComputedStyle(img), w = img.getBoundingClientRect().width;
    if (cs.opacity === '0' || cs.visibility === 'hidden') { img.dataset.gllfAi = ''; return; } // hover-swap second image
    if (w > 0 && w < 90) return; // gallery thumbnails stay clean
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var handle = handleFor(img), title = titleFor(img, handle), plant = isPlant(img, handle, title);
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'gllf-ai-badge';
    btn.dataset.kind = kind; btn.dataset.name = shortName(title, plant); btn.dataset.plant = plant ? '1' : '0'; btn.dataset.occ = occasion(img.getAttribute('alt')); btn.dataset.handle = handle;
    var occ = btn.dataset.occ;
    btn.setAttribute('aria-label', kind === 'styled' ? 'About this picture: real product, ' + (occ ? occ + ' ' : 'creative ') + 'setting' : 'About this picture: creative inspiration');
    btn.setAttribute('aria-describedby', 'gllf-ai-tip'); btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<svg aria-hidden="true" focusable="false"><use href="#gllf-ai-' + iconFor(kind, occ) + '"></use></svg>';
    btn.addEventListener('mouseenter', function(){ fit(btn); show(btn); });
    btn.addEventListener('mouseleave', function(){ hide(); });
    btn.addEventListener('focus', function(){ show(btn); });
    btn.addEventListener('blur', function(){ hide(); });
    btn.addEventListener('keydown', function(e){ var l = tip.querySelector('a'); if (e.key === 'Tab' && !e.shiftKey && l && openBtn === btn) { e.preventDefault(); l.focus(); } });
    // Inside product links: a tap opens the note instead of following the link.
    btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); if (openBtn === btn && tip.dataset.open === 'true' && e.pointerType !== 'mouse' && Date.now() - shownAt > 450) hide(true); else show(btn); });
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function(t){ btn.addEventListener(t, function(e){ e.stopPropagation(); }, {passive: true}); });
    host.appendChild(btn);
    fit(btn);
    if (sizer) sizer.observe(btn);
  }
  function scan(root){
    (root.querySelectorAll ? root : document).querySelectorAll('img[alt]').forEach(badge);
    if (root.tagName === 'IMG') badge(root);
  }
  scan(document);
  new MutationObserver(function(list){
    list.forEach(function(m){
      if (m.type === 'attributes') { m.target.removeAttribute('data-gllf-ai'); var old = m.target.parentElement && m.target.parentElement.querySelector(':scope > .gllf-ai-badge'); if (old && !kindOf(m.target.getAttribute('alt'))) old.remove(); badge(m.target); return; }
      m.addedNodes.forEach(function(n){ if (n.nodeType === 1) scan(n); });
    });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['alt']});
})();
